module.exports = __webpack_public_path__ + "img/Sequencing.c4a0ff09.png";